import { Component, OnInit, inject } from "@angular/core";
import { TabService } from "@services/tabs/TabService";
import { Pages } from "@constants/pages/Pages";
import { PermissionsService } from "@services/permissions/PermissionsService";
import { MicroservicePermissionService } from "@services/permissions/permissions.service";
import { MicroserviceModule } from "@enums/microservice-module.enum";
import { injectTranslation } from "@app/shared/i18n/translation-scope";
import { scope } from "./i18n/scope";
import { NgxMasonryModule } from "ngx-masonry";
import { CerrixLoaderComponent } from "@app/shared/components/cerrix-loader/cerrix-loader.component";
import { ExportRisksComponent } from "./exporttypes/risks/export-risks.component";
import { ExportEventsComponent } from "./exporttypes/events/export-events.component";
import { ExportControlsComponent } from "./exporttypes/controls/export-controls.component";
import { ExportBimComponent } from "./exporttypes/bim/export-bim.component";
import { ExportDatamanagementComponent } from "./exporttypes/datamanagement/export-datamanagement.component";
import { ExportTasksComponent } from "./exporttypes/tasks/export-tasks.component";
import { ExportIncidentsComponent } from "./exporttypes/incidents/export-incidents.component";
import { ExportUsersComponent } from "./exporttypes/users/export-users.component";
import { KrisDataPointsExportComponent } from "./kri/kris-data-points-export/kris-data-points-export.component";

@Component({
    selector: "app-export-overview",
    templateUrl: "./export-overview.component.html",
    styleUrls: ["./export-overview.component.scss"],
    imports: [
        NgxMasonryModule,
        CerrixLoaderComponent,
        ExportRisksComponent,
        ExportEventsComponent,
        KrisDataPointsExportComponent,
        ExportControlsComponent,
        ExportBimComponent,
        ExportDatamanagementComponent,
        ExportUsersComponent,
        ExportTasksComponent,
        ExportIncidentsComponent,
    ]
})
export class ExportOverviewComponent implements OnInit {
    tabService = inject(TabService);
    pages = inject(Pages);
    permService = inject(PermissionsService);
    private microservicePermissionService = inject(MicroservicePermissionService);
    private translation = injectTranslation(scope);

    downloadlink: string;
    public hasIncidentAccess: boolean = false;
    protected finishedLoading = false;

    async ngOnInit() {
        this.hasIncidentAccess =
            this.permService.permissions.HasIncidentAccess &&
            this.microservicePermissionService.hasModuleAccess(MicroserviceModule.Incidents);

        // Each export card mounts with its own "export" scope pipes, and ngx-masonry measures
        // a card's height the moment it mounts. If the scope is still loading, a card's buttons
        // render later, but masonry never re-measures, so the next card gets positioned over
        // the still-growing one. Load the scope here first so every card mounts with its final
        // content already in place.
        try {
            await this.translation.ready();
        } catch {
            // Scope failed to load; render cards anyway so the page is not stuck blank.
        }

        this.finishedLoading = true;
    }
}
